import React, { useEffect, useState, useRef} from "react";
import { Paper } from "@material-ui/core";
import "../../styles/devices/mob_UserProfile.css";
import { useDataProvider } from "../../api/DataProvider";
import { useCommProvider } from "../../api/CommProvider";
import { DataGrid } from "@material-ui/data-grid";
import { Button, IconButton, Select, MenuItem } from '@mui/material';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { SignDialog } from "../../components/dialog/SignDialog";
import RecommendIcon from '@mui/icons-material/Recommend';
import CancelIcon from '@mui/icons-material/Cancel';

import AssignmentIcon from '@mui/icons-material/Assignment';
import { FormCreateTaskDialog } from "./FormCreateTaskDialog";

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import CloseIcon from '@mui/icons-material/Close';

import ConfirmationDialog from '../utils/ConfirmationDialog';
import { useTranslation } from "react-i18next";

import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import VideoCameraFrontIcon from '@mui/icons-material/VideoCameraFront';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import WarningIcon from '@mui/icons-material/Warning';

import ModeEditIcon from '@mui/icons-material/ModeEdit';

import { RecordDialog } from "../../components/dialog/RecordDialog";
import { pDataOrigin, pDataTypeVideo, pDataOriginLabel, pTeamActivityViewTab, pDataProvider } from "../../utils/parameters";
import { use } from "i18next";

import Chip from '@mui/material/Chip';
import { formatHistoryDate, formatDiffDate } from '../../api/utils/strings';

import LockIcon from '@mui/icons-material/Lock';
import NoEncryptionGmailerrorredIcon from '@mui/icons-material/NoEncryptionGmailerrorred';

import { DeviceQueries } from "../utils/DeviceQueries";


import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';

import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import BookmarkAddedIcon from '@mui/icons-material/BookmarkAdded';
import BlockIcon from '@mui/icons-material/Block';
import HourglassDisabledIcon from '@mui/icons-material/HourglassDisabled';


import VideocamIcon from '@mui/icons-material/Videocam';
import VideocamOffIcon from '@mui/icons-material/VideocamOff';

import Tooltip from '@mui/material/Tooltip';

import DialogInfo from "../moveYourSkeletonDialog/DialogInfo";
import { Dialog, DialogContent, DialogActions } from "@material-ui/core";

import CalculateIcon from '@mui/icons-material/Calculate';
import AccessTimeIcon from '@mui/icons-material/AccessTime';


export function TaskTeams(props) {
    const { infoTeam, task_id_selected, setTask_id_selected, refresh_InfoTeam, isAdmin } = props
    const { t } = useTranslation("global")

    const [ openDialogSign, setOpenDialogSign ] = useState(false);
    const [ openDialogRecord, setOpenDialogRecord ] = useState(false);
    const [ openDialogCreateTaskForm, setOpenDialogCreateTaskForm ] = useState(false);
    const [ prevTaskFormData, setPrevTaskFormData ] = useState(null);

    const [ isComfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);

    const [ selected_record, setSelectedRecord ] = useState({});
    const [ selected_video, setSelectedVideo ] = useState(null);
    const [ selected_videoRef, setSelectedVideoRef ] = useState(null);


    const [ resume_task_data, setResume_task_data ] = useState([])               // Info about task selected
    const [ body_task_data, setBody_task_data ] = useState([])          // Info about task selected
    const [ arrDataGrid, setArrDataGrid ] = useState([])                        // Info datagrid respect task and target_user


    const { currentUser, token_id, genEntryByLemma, getLemmaMeaningByGloss, json_data_lemma, json_data_meaning, json_data_glosses, comm_getPublicURLVideoData } = useDataProvider();
    const { comm_getTaskTeam, comm_createTaskTeam, comm_updateTaskTeam, comm_removeTaskTeam, comm_updateTeam, comm_getInfoTeam, comm_getVideoData, comm_getRecords, updateFeedbackRecord } = useCommProvider();
   
    /* MOB - Nav responsiveness */
    const queryMatches = DeviceQueries();

    
    // Show signVideos
    const [ dialogElements, setDialogElements ] = useState([]);
    const [ prevDialogPosition, setPrevDialogPosition ] = useState(undefined);

    const [ listActiveMembers, setListActiveMembers] = useState([]);
    const [ listActiveMembersIdx, setListActivateMembersIdx] = useState([]);

    const [ target_user_id, setTarget_user_id ] = useState("")
    // const [ timeEndDetected, setTimeEndDetected ] = useState({}) 
    const timeEndDetectedRef = useRef({});

    const [isLoadingDataGrid, setIsLoadingDataGrid] = useState(true);


    const [openComfirmCancelDialog, setOpenComfirmCancelDialog] = useState(false);
    const remove_params_ref = useRef(null)

    const [openDialogReportRecord, setOpenDialogReportRecord] = useState(false)
    const [server_report_activity, setServer_report_activity] = useState(0)
    const [user_vid_original, set_user_vid_original] = useState(null)
    const [user_vid_keypoints, set_user_vid_keypoints] = useState(null)
    const [user_vid_overlay, set_user_vid_overlay] = useState(null)


    // const [sortModel, setSortModel] = useState([{ field: "name", sort: "asc" }]);

    const [columnsALL, setColumnsALL] = useState([
        { field: "name", headerName: t("sTable.name"), sortable: false, flex: 0.3 },
        { field: "gloss", headerName: "ID", sortable: false, flex: 0.3 },
        { field: "participation", headerName: "Participaciones", headerAlign: "center", sortable: false, flex: 0.35 , align: "center"},
        { field: "revised", headerName: "Evaluados", headerAlign: "center", sortable: false, flex: 0.35 , align: "center"},
        // { field: "total", headerName: "Nº vídeos", headerAlign: "center", sortable: false, flex: 0.3 , align: "center"},
        { field: "action", headerName: "Acción", headerAlign: "center", sortable: false, flex: 0.3 , align: "center", renderCell: (params) => gridShowLemmmaAction(params)},
    ]);


    const [columns, setColumns] = useState([
        { field: "name", headerName: t("sTable.name"), sortable: false, flex: 0.25 },
        { field: "gloss", headerName: "ID", sortable: false, flex: 0.25 },
        // { field: "record_data", headerName: t("sTable.participation"), headerAlign: "center", sortable: false, flex: 0.2 , align: "center", renderCell: (params) => gridTaskRecord(params)},
        { field: "evaluated", headerName: "Estado", headerAlign: "center", sortable: false, flex: 0.2 , align: "center", renderCell: (params) => gridStatusRecord(params)},
        // { field: "evaluated", headerName: t("sTable.evaluated"), headerAlign: "center", sortable: false, flex: 0.2 , align: "center", renderCell: (params) => gridTaskEvaluated(params)},
        // { field: "timestamp", headerName: t("sRecorder.record_field_date"), headerAlign: "center", sortable: false, flex: 0.2, renderCell: (params) => formatDate(params) },
        { field: "timestamp", headerName: t("sRecorder.record_field_date"), headerAlign: "center", align: "center", sortable: false, flex: 0.15, renderCell: (params) => gridShowTimestamp(params)  },
        { field: "report", headerName: "P", headerAlign: "center", sortable: false, flex: 0.1 , align: "center", renderCell: (params) => gridReportRecord(params)},
        { field: "action", headerName: "Acción", headerAlign: "center", sortable: false, flex: 0.3 , align: "center", renderCell: (params) => gridAction(params)},
    ]);

    function gridShowLemmmaAction(params) {
        return (
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '2px'}}>
                <Button style={{backgroundColor: '#5ea0d4'}} className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug" onClick={() => handleShowVideoRef(params)}> <OndemandVideoIcon/> </Button>
            </div>
        )
    }

    // import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
    // import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';

    // import VideocamIcon from '@mui/icons-material/Videocam';
    // import VideocamOffIcon from '@mui/icons-material/VideocamOff';

    // import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
    // import BookmarkAddedIcon from '@mui/icons-material/BookmarkAdded';
    // import BlockIcon from '@mui/icons-material/Block';
    // import HourglassDisabledIcon from '@mui/icons-material/HourglassDisabled';

    // Para ENVIADO utilizar <MarkEmailReadIcon/>
    // Para PENDIENTE utilizar <HourglassBottomIcon/>
    // Para REVISADO utilizar <BookmarkAddedIcon/>
    // Para BLOQUEADO utilizar <BlockIcon/>
    // Para TIMEOUT utilizar <HourglassDisabledIcon/>

    
    function gridShowTimestamp(params){

        if (params.row.participation){
            return <Tooltip 
                        classes={{arrow: "sig_CustomTooltip_Arrow", tooltip: "sig_CustomTooltip_Container"}}
                        placement="top"
                        enterTouchDelay={50}
                        arrow
                        title={
                        <div className="sig_CustomTooltip_Content">
                            <span> {formatDate(params)} </span>
                        </div>
                    }>
                        <AccessTimeIcon style={{color:'#026bbc'}}/>
                    </Tooltip>
        }else{
            return "-"
        }
    }

    function gridStatusRecord2(params){
        // console.log("🚀 ~ file: TaskTeams.js:116 ~ gridStatusRecord ~ params:", params)
        let status = ''
        if (params.row.participation){
            status = 'GRABADO'
        }else{
            status = 'PTDE DE GRABAR'
        }
        

        if (params.row.revised){
            status = status + ', REVISADO'
        }

        if (params.row.blocked){
            status = status + ', BLOQUEADO'
        }

        if (params.row.timeEndDetected){
            status = status + ', TIMEOUT'
        }

        return (
            <p style={{ whiteSpace: 'normal', wordWrap: 'break-word', margin: 0, padding: 0, lineHeight: 1 }}>
                {status}
            </p>
        );
    }

    function gridReportRecord(params) {

        const getBackgroundColor = () => {
            const value = params.row.report[9];
            if (value < 30) {
                return 'red';
            } else if (value < 60) {
                return 'orange';
            } else {
                return 'green';
            }
        };


        if (params.row.participation){
            if (params.row.report.length > 0 ){
                // return <Button style={{ border: '2px solid red', borderRadius: '10px', backgroundColor: getBackgroundColor(), height:'80%', color:'white'}} onClick={()=>handleGetReportVideos(params)}> <p>{params.row.report[9]}</p> </Button>

                return <Tooltip 
                            classes={{arrow: "sig_CustomTooltip_Arrow", tooltip: "sig_CustomTooltip_Container"}}
                            placement="top"
                            enterTouchDelay={50}
                            arrow
                            key="calculating"
                            title={
                            <div className="sig_CustomTooltip_Content">
                                <span> PUNTUACIÓN AUTOMÁTICA DEL VÍDEO </span>
                            </div>
                        }>
                            <Button style={{ border: '2px solid red', borderRadius: '10px', backgroundColor: getBackgroundColor(), height:'80%', color:'white'}} onClick={()=>handleGetReportVideos(params)}> <p>{params.row.report[9]}</p> </Button>
                        </Tooltip>

            }else{
                return <Tooltip 
                            classes={{arrow: "sig_CustomTooltip_Arrow", tooltip: "sig_CustomTooltip_Container"}}
                            placement="top"
                            enterTouchDelay={50}
                            arrow
                            key="calculating"
                            title={
                            <div className="sig_CustomTooltip_Content">
                                <span> PROCESANDO... </span>
                            </div>
                        }>
                            <CalculateIcon style={{color:'#026bbc'}}/>
                        </Tooltip>
                }
        }else{
            return <p>-</p>
        }

        
    }

    async function handleGetReportVideos(params) {
        setSelectedRecord(params.row.record_data)
        setServer_report_activity(params.row.report[9])
        set_user_vid_original(await comm_getVideoData(token_id, currentUser, pDataOrigin.collaboration_LABEL, params.row.record_data.filename));
        set_user_vid_keypoints(await comm_getVideoData(token_id, currentUser, pDataOrigin.mediapipe_LABEL, params.row.record_data.filename, pDataTypeVideo.video_KEYPOINTS));
        set_user_vid_overlay(await comm_getVideoData(token_id, currentUser, pDataOrigin.mediapipe_LABEL, params.row.record_data.filename, pDataTypeVideo.video_OVERLAY));
        setOpenDialogReportRecord(true)
    }



    function gridStatusRecord(params){
        // console.log("🚀 ~ file: TaskTeams.js:116 ~ gridStatusRecord ~ params:", params)
    
        const icons = [];
    
        if (params.row.participation){
            icons.push(
                <Tooltip 
                    classes={{arrow: "sig_CustomTooltip_Arrow", tooltip: "sig_CustomTooltip_Container"}}
                    placement="top"
                    arrow
                    enterTouchDelay={50}
                    key="enviado"
                    title={
                    <div className="sig_CustomTooltip_Content">
                        <strong style={{color: 'green'}}> ENVIADO </strong>
                    </div>
                    }>
                    <VideocamIcon style={{color: 'green'}}/>
                </Tooltip>
            )

            if (params.row.warning){

                icons.push(
                    <Tooltip 
                        classes={{arrow: "sig_CustomTooltip_Arrow", tooltip: "sig_CustomTooltip_Container"}}
                        placement="top"
                        arrow
                        enterTouchDelay={50}
                        key="warning"
                        title={
                        <div className="sig_CustomTooltip_Content">
                            <strong style={{color: 'red'}}> ERROR REPORTADO </strong>
                        </div>
                        }>
                        <WarningIcon style={{color: 'red'}}/>
                    </Tooltip>
                )

            }else{
                if (params.row.revised){
                    icons.push(

                        <Tooltip 
                            classes={{arrow: "sig_CustomTooltip_Arrow", tooltip: "sig_CustomTooltip_Container"}}
                            placement="top"
                            arrow
                            enterTouchDelay={50}
                            key="revisado"
                            title={
                            <div className="sig_CustomTooltip_Content">
                                <strong style={{color: 'green'}}> REVISADO </strong>
                            </div>
                            }>
                            <BookmarkAddedIcon style={{color: 'green'}}/>
                        </Tooltip>



                    )
                }else {
                    icons.push(

                        <Tooltip 
                            classes={{arrow: "sig_CustomTooltip_Arrow", tooltip: "sig_CustomTooltip_Container"}}
                            placement="top"
                            arrow
                            enterTouchDelay={50}
                            key="pendiente"
                            title={
                            <div className="sig_CustomTooltip_Content">
                                <strong style={{color: 'red'}}> PTDE DE REVISIÓN </strong>
                            </div>
                            }>
                            <HourglassBottomIcon style={{color: 'red'}}/>
                        </Tooltip>

                    )
                }
            }

        } else {
            icons.push(
                <Tooltip 
                    classes={{arrow: "sig_CustomTooltip_Arrow", tooltip: "sig_CustomTooltip_Container"}}
                    placement="top"
                    arrow
                    enterTouchDelay={50}
                    key="pendiente"
                    title={
                    <div className="sig_CustomTooltip_Content">
                        <strong style={{color: 'red'}}> PTDE DE GRABAR </strong>
                    </div>
                    }>
                    <VideocamOffIcon style={{color: 'red'}}/>
                </Tooltip>
            )
        }
    
        if (params.row.blocked){
            icons.push(
                <Tooltip 
                    classes={{arrow: "sig_CustomTooltip_Arrow", tooltip: "sig_CustomTooltip_Container"}}
                    placement="top"
                    arrow
                    enterTouchDelay={50}
                    key="bloqueado"
                    title={
                    <div className="sig_CustomTooltip_Content">
                        <strong style={{color: 'red'}}> BLOQUEADO </strong>
                    </div>
                    }>
                    <BlockIcon style={{color: 'red'}}/>
                </Tooltip>
            )
        }
    
        if (params.row.timeEndDetected){
            icons.push(
                <Tooltip 
                    classes={{arrow: "sig_CustomTooltip_Arrow", tooltip: "sig_CustomTooltip_Container"}}
                    placement="top"
                    arrow
                    enterTouchDelay={50}
                    key="timeout"
                    title={
                    <div  className="sig_CustomTooltip_Content">
                        <strong style={{color: 'red'}}> Tiempo límite </strong>
                    </div>
                    }>
                    <HourglassDisabledIcon style={{color: 'red'}}/>
                </Tooltip>
            )
        }
    
        return (
            <p style={{ whiteSpace: 'normal', wordWrap: 'break-word', margin: 0, padding: 0, lineHeight: 1 }}>
                {icons}
            </p>
        );
    }

    function gridTaskRecord(params) {
        return (params.row.participation == true) ? <RecommendIcon style={{ color: 'green' }} /> : <CancelIcon style={{ color: 'red' }} />;
    }

    function gridTaskEvaluated(params) {
        if (params.row.warning !== '') {
            return <WarningIcon style={{ color: 'red' }} />;
        }
    
        if (params.row.participation === true) {
            return (params.row.revised == true) 
                ? <RecommendIcon style={{ color: 'green' }}/> 
                : <CancelIcon style={{ color: '#5ea0d4' }}/>;
        } else {
            return <div style={{ margin: 'auto' }}> - </div>;
        }
    }

    function formatDate(params) {

        try{

            let timestampMilliseconds = params.row.timestamp;

            if (timestampMilliseconds.length === 16) {
                timestampMilliseconds = timestampMilliseconds / 1000;
            }
            
            return <div style={{margin: 'auto'}}> {new Intl.DateTimeFormat('es-ES', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                        }).format(timestampMilliseconds)}
                    </div>

        } catch {
            return <div style={{margin: 'auto'}}>  -   </div>
        }

        
       
    }

    function gridAction(params) {
        return (
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '2px'}}>
                
                { params.row.participation
                ?
                    <>
                        <Button style={{backgroundColor: 'green'}} className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug" onClick={() => handleRowClickSignDialog(params)}> <PlayCircleOutlineIcon/> </Button>

                        { isAdmin || params.row.evaluated == true ? 
                            <></> : 
                            <Button 
                                style={{backgroundColor: 'red', marginLeft: '10px'}} 
                                className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug" 
                                onClick={() => {remove_params_ref.current = params; setOpenComfirmCancelDialog(true)}}
                                disabled={ params.row.blocked || params.row.timeEndDetected }> 
                                <CancelIcon/> 
                            </Button>
                        }


                        { !isAdmin ? <></> : (params.row.blocked == true ) ? <Button style={{backgroundColor: '#026bbc'}} onClick={() => handleClickLockerButton(params)} className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug"> <NoEncryptionGmailerrorredIcon/> </Button> : <Button style={{backgroundColor: '#5ea0d4'}} onClick={() => handleClickLockerButton(params)} className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug"> <LockIcon/> </Button> }
                    </>
                :   
                    <>
                        { isAdmin 
                            ? <Button style={{backgroundColor: '#5ea0d4'}} className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug" onClick={() => handleShowVideoRef(params)}> <OndemandVideoIcon/> </Button>
                            : <Button style={{backgroundColor: '#5ea0d4'}} className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug" disabled={ params.row.blocked || params.row.timeEndDetected } onClick={() => handleShowVideoRef(params)}> {t("sRecordComponent.recordButton")} </Button>
                        }
                    </>
                }
            </div>
        )
    }

    async function handleClickLockerButton(params) {
        // console.log("🚀 ~ file: TaskTeams.js:145 ~ handleClickLockerButton ~ handleClickLockerButton:", handleClickLockerButton)

        // console.log("🚀 ~ file: TaskTeams.js:145 ~ handleClickLockerButton ~ params:", params)

        let evaluationData = params.row.record_data.feedback_report
        // console.log("🚀 ~ file: TaskTeams.js:177 ~ handleClickLockerButton ~ evaluationData:", evaluationData)
        evaluationData.blocked = !evaluationData.blocked;
        // console.log("🚀 ~ file: TaskTeams.js:177 ~ handleClickLockerButton ~ evaluationData:", evaluationData)

        await updateFeedbackRecord(token_id, currentUser, params.row.record_data._id, evaluationData); 
        refresh_task_data(params)


        // setEvaluationData(prevData => ({
        //     ...prevData, // Spread the previous data to maintain other fields
        //     blocked: !prevData.blocked // Toggle the 'blocked' field
        // }));
    }
    

    

    async function handleShowVideoRef(params) {
        const { lemma, meaning } = getLemmaMeaningByGloss(params.row.id);
        const dialog_elements_obtained = genEntryByLemma([lemma]);
        setDialogElements(dialog_elements_obtained);
        setPrevDialogPosition({
            "lemma": lemma,
            "meaning": meaning,
            "gloss": params.row.id
        })
    }

    async function handleDiscardRecord() {

        // console.log(remove_params_ref.current)
        const params = remove_params_ref.current

        const data_in = {
            "remove": true,
            "element_id": params.row.id,
            "record_id": params.row.record_data._id
        }

        // console.log("🚀 ~ file: TaskTeams.js:145 ~ handleDiscardRecord ~ data_in:", data_in)
        // console.log("🚀 ~ file: TaskTeams.js:145 ~ handleDiscardRecord ~ infoTeam:", infoTeam)
        // console.log("🚀 ~ file: TaskTeams.js:145 ~ handleDiscardRecord ~ team_id:", params.row.team_id)
        // console.log("🚀 ~ file: TaskTeams.js:145 ~ handleDiscardRecord ~ task_id_selected:", params.row.task_id)
        // console.log("🚀 ~ file: TaskTeams.js:145 ~ handleDiscardRecord ~ target_user_id:", params.row.target_user_id)

        setOpenComfirmCancelDialog(false)
        

        await comm_updateTaskTeam(token_id, currentUser, params.row.task_id, data_in)
        refresh_task_data(params)

    }

    async function handleRowClickSignDialog(params, event) {
        setSelectedRecord(params.row.record_data)
        setSelectedVideo(await comm_getVideoData(token_id, currentUser, pDataOrigin.collaboration_LABEL, params.row.record_data.filename));
        setSelectedVideoRef(await comm_getPublicURLVideoData(pDataProvider.dir_vid_sign, params.row.record_data.reference))
        setOpenDialogRecord(true);
    }


    

    // USEEFFECTS

    useEffect(() => {

        // console.log("🚀 ~ file: TaskTeams.js:201 ~ TaskTeams_infoTeam:", infoTeam)

        if (infoTeam && Object.keys(infoTeam).length > 0) {

            // console.log("🚀 ~ file: TaskTeams.js:201 ~ TaskTeams_infoTeam22222:", target_user_id)            

            if (isAdmin){
                const arr_active_members = infoTeam['users_state']
                    .filter(item => item['accesible'])
                    .map(item => "["+item['id']+"] - "+ item['name']);
                    
                const arr_active_members_idx = infoTeam['users_state']
                    .filter(item => item['accesible'])
                    .map(item => item['id']);

                setListActiveMembers(arr_active_members)
                setListActivateMembersIdx(arr_active_members_idx)

                if (target_user_id === ''){
                    setTarget_user_id('ADMIN')
                }
            }else{
                setTarget_user_id(currentUser.uid)
            }

        }

    }, [infoTeam]);


    useEffect(() => {
        // Cleanup function
        return () => {
            // console.log('RESET ALL DATA')
            setResume_task_data([]);
            setBody_task_data([]);
            setArrDataGrid([])
            setTarget_user_id('')
        };
    }, []);

    // PENDIENTE DE AJUSTAR - SE RENDERIZA MULTIPLES VECES AL ATENDER A VARIOS PARÁMETROS QUE "SUELE" CAMBIAR POR EJEMPLO AL VOLVER DE UNA GRABACIÓN - RENDERIZA 3 VECES [infoTeam, task_id_selected, target_user_id]
    useEffect(() => {

        // console.log("🚀 ~ file: TaskTeams.js:229 ~ TaskTeams ~ SWITCH_UPDATE   infoTeam:", infoTeam)
        // console.log("🚀 ~ file: TaskTeams.js:229 ~ TaskTeams ~ SWITCH_UPDATE   target_user_id:", target_user_id)
        // console.log("🚀 ~ file: TaskTeams.js:229 ~ TaskTeams ~ SWITCH_UPDATE   task_id_selected:", task_id_selected)

        if (target_user_id !== ''){

            updateResume_task_data()
            
            if (task_id_selected == ''){

                // console.log("🚀 ~ file: TaskTeams.js:229 ~ TaskTeams ~ SWITCH_UPDATE   setBody_task_data:")

                setBody_task_data([])
            }else{

                // console.log("🚀 ~ file: TaskTeams.js:229 ~ TaskTeams ~ SWITCH_UPDATE   updateTeamTaskScreen_Datagrids:")

                updateTeamTaskScreen_Datagrids()
            }
        }
        
    }, [infoTeam, task_id_selected, target_user_id]);
    


    async function updateResume_task_data(){
        // console.log("🚀 ~ file: TaskTeams.js:150 ~ TaskTeams ~ updateResume_task_data  infoTeam:", infoTeam['_id'])
        // console.log("🚀 ~ file: TaskTeams.js:150 ~ TaskTeams ~ updateResume_task_data  task_id_selected: --- RESUME")
        // console.log("🚀 ~ file: TaskTeams.js:150 ~ TaskTeams ~ updateResume_task_data  target_user_id:", target_user_id)
        
        setResume_task_data(await comm_getTaskTeam(token_id, currentUser, infoTeam['_id'], 'RESUME', target_user_id))

        // if (isAdmin){
        //     setResume_task_data(await comm_getTaskTeam(token_id, currentUser, infoTeam['_id'], 'RESUME', 'ADMIN'))
        // }else{       
        //     setResume_task_data(await comm_getTaskTeam(token_id, currentUser, infoTeam['_id'], 'RESUME', target_user_id))
        // }
    }

    async function updateTeamTaskScreen_Datagrids(){
            
        // console.log("🚀 ~ file: TaskTeams.js:150 ~ TaskTeams ~ updateTeamTaskScreen_Datagrids  infoTeam:", infoTeam['_id'])
        // console.log("🚀 ~ file: TaskTeams.js:150 ~ TaskTeams ~ updateTeamTaskScreen_Datagrids  task_id_selected:", task_id_selected)
        // console.log("🚀 ~ file: TaskTeams.js:150 ~ TaskTeams ~ updateTeamTaskScreen_Datagrids  target_user_id:", target_user_id)
        

        setBody_task_data(await comm_getTaskTeam(token_id, currentUser, infoTeam['_id'], task_id_selected, target_user_id))
    }


    // Format arrDataGrid respect selectTask
    useEffect(() => {

        if (body_task_data && body_task_data.length > 0) {
            // console.log("🚀 ~ file: TaskTeams.js:150 ~ TaskTeams ~ GET_body_task_data   --   Format arrDataGrid respect selectTask")

            if (target_user_id === 'ADMIN'){
                const arrDataFormatted = Object.entries(body_task_data[0]['data']).map(([key, value]) => {
                    const { lemma, meaning } = getLemmaMeaningByGloss(key);
                    return {
                        id: key,
                        name: json_data_lemma[lemma] && json_data_lemma[lemma]['label'] ? json_data_lemma[lemma]['label'] : 'Unknown', // Default to 'Unknown' if not present
                        gloss: json_data_glosses[key]['label'],
                        participation: value.participation || 0,  // Default to 0 if not present
                        revised: value.revised || 0,              // Default to 0 if not present
                        total: value.total || 0,                  // Default to 0 if not present

                        team_id : infoTeam['_id'],
                        task_id : task_id_selected,
                        target_user_id : target_user_id,
                        report:[]
                    };
                });
    
                setArrDataGrid(arrDataFormatted)

            }else{
    
                const arrDataFormatted = Object.entries(body_task_data[0]['data']).map(([key, value]) => {
                    const { lemma, meaning } = getLemmaMeaningByGloss(key);
                    const isRecordDataEmpty = value.record_data && Object.keys(value.record_data).length === 0;

                    // console.log("🚀 ~ file: TaskTeams.js:401 ~ arrDataFormatted ~ task_id_selected:", task_id_selected)
                    // console.log("🚀 ~ file: TaskTeams.js:401 ~ arrDataFormatted ~ timeEndDetectedRef:", timeEndDetectedRef)
                    // console.log("🚀 ~ file: TaskTeams.js:401 ~ arrDataFormatted ~ timeEndDetectedRef.current[task_id_selected]:", timeEndDetectedRef.current[task_id_selected])

                    return {
                        id: key,
                        name: json_data_lemma[lemma] && json_data_lemma[lemma]['label'] ? json_data_lemma[lemma]['label'] : 'Unknown', // Default to 'Unknown' if not present
                        gloss: json_data_glosses[key]['label'],
                        record_data: value.record_data || {},       // Default to {} if not present
                        participation: !isRecordDataEmpty,
                        revised: value.revised || false,             // Default to 0 if not present

                        warning: value.warning || '',
                        
                        timeEndDetected : timeEndDetectedRef.current[task_id_selected],
                        blocked: timeEndDetectedRef.current[task_id_selected] ? true : (value.blocked || false), 

                        report: value.record_data.report || [],

                        team_id : infoTeam['_id'],
                        task_id : task_id_selected,
                        target_user_id : target_user_id,

                        timestamp : value.record_data.timestamp || '-'
                        
                        
                    };
                });
    
                setArrDataGrid(arrDataFormatted)
                // console.log('body_task_data  NOT FORMATTED   -  ', target_user_id)
                
            }

        } else{
            setArrDataGrid([])
        }
        
        
    }, [body_task_data]);


    useEffect(() => {
        if (Object.keys(dialogElements).length > 0) {
          setOpenDialogSign(true);
        }else{
          setOpenDialogSign(false);
        }
    }, [dialogElements]);
    



    // SHOW INPUT DATA

    // useEffect(() => {
    //     console.log("🚀 ~ file: SHOW TaskTeams.js:159 ~ TaskTeams ~ GET_resume_task_data:", resume_task_data)
    // }, [resume_task_data]);

    // useEffect(() => {
    //     console.log("🚀 ~ file: SHOW TaskTeams.js:163 ~ TaskTeams ~ body_task_data:", body_task_data)
    // }, [body_task_data]);

    // useEffect(() => {
    //     console.log("🚀 ~ file: SHOW TaskTeams.js:167 ~ TaskTeams ~ isAdmin:", isAdmin)
    // }, [isAdmin]);

    useEffect(() => {
        // console.log("🚀 ~ file: SHOW TaskTeams.js:221 ~ TaskTeams ~ arrDataGrid:", arrDataGrid)

        if (arrDataGrid && arrDataGrid.length > 0) {
            // console.log('IS_LOADING_DATAGRID_FALSE')
            setIsLoadingDataGrid(false)

                setTimeout(() => {
                  const seccion = document.getElementById("summary_" + task_id_selected);
                  if (seccion) {
                    seccion.scrollIntoView({ behavior: 'smooth' });
                  }
                }, 200); // Retrasar 500 ms, ajustar según sea necesario

        }else{
            // console.log('IS_LOADING_DATAGRID_TRUE')
            setIsLoadingDataGrid(true)
        }
        
    }, [arrDataGrid]);

    // useEffect(() => {
    //     console.log("🚀 ~ file: SHOW TaskTeams.js:221 ~ TaskTeams ~ selected_record:", selected_record)
    // }, [selected_record]);
    
    // useEffect(() => {
    //     console.log("🚀 ~ file: SHOW TaskTeams.js:221 ~ TaskTeams ~ isComfirmDialogOpen:", isComfirmDialogOpen)
    // }, [isComfirmDialogOpen]);

    // useEffect(() => {
    //     console.log("🚀 ~ file: SHOW TaskTeams.js:221 ~ TaskTeams ~ task_id_selected:", task_id_selected)
    // }, [task_id_selected]);

    // useEffect(() => {
    //     console.log("🚀 ~ file: SHOW TaskTeams.js:221 ~ TaskTeams ~ target_user_id:", target_user_id)
    // }, [target_user_id]);

    // useEffect(() => {
    //     console.log("🚀 ~ file: SHOW TaskTeams.js:221 ~ TaskTeams ~ timeEndDetected.current:", timeEndDetectedRef.current)
    // }, [timeEndDetectedRef.current]);



    


    // FUNCTIONS

    async function sendHideTask(task_id, visibility) {
        // console.log("🚀 ~ file: TaskTeams.js:294 ~ SETTING sendHideTask ~ task_id:", task_id)
        const data = {
            "visibility": !visibility,
        }
        await comm_updateTaskTeam(token_id, currentUser, task_id, data)
        refresh_InfoTeam()
        // setTask_data(await comm_getTaskTeam(token_id, currentUser, infoTeam['_id'], target_user_id))
    }

    async function sendDeleteTask(task_id) {
        // console.log("🚀 ~ file: TaskTeams.js:302 ~ SETTING  sendDeleteTask ~ task_id:", task_id)
        await comm_removeTaskTeam(token_id, currentUser, infoTeam['_id'], task_id)
        refresh_InfoTeam()
    }

    async function sendChangePositionTask(index, action) {
        let arr_task = infoTeam['arr_task']
        if (action){
            const temp = arr_task[index]
            arr_task[index] = arr_task[index - 1]
            arr_task[index - 1] = temp
        }else{
            const temp = arr_task[index]
            arr_task[index] = arr_task[index + 1]
            arr_task[index + 1] = temp
        }
        
        const data = {
            'arr_task' : arr_task 
        }
        await comm_updateTeam(token_id, currentUser, infoTeam['_id'], data)
        refresh_InfoTeam()
    }






    // FUNCTIONS - HANDLE FUNCTIONS 

    async function refresh_task_data(params){
        // console.log("🚀 ~ file: TaskTeams.js:380 ~ refresh_task_data ~ infoTeam:", infoTeam)
        // console.log("🚀 ~ file: TaskTeams.js:380 ~ refresh_task_data ~ task_id_selected:", task_id_selected)
        // console.log("🚀 ~ file: TaskTeams.js:380 ~ refresh_task_data ~ target_user_id:", target_user_id)

        // console.log("🚀 ~ file: TaskTeams.js:145 ~ refresh_task_data ~ team_id:", params.row.team_id)
        // console.log("🚀 ~ file: TaskTeams.js:145 ~ refresh_task_data ~ task_id_selected:", params.row.task_id)
        // console.log("🚀 ~ file: TaskTeams.js:145 ~ refresh_task_data ~ target_user_id:", params.row.target_user_id)
        
        
        setResume_task_data(await comm_getTaskTeam(token_id, currentUser, params.row.team_id, 'RESUME', params.row.target_user_id))

        setIsLoadingDataGrid(true)
        setBody_task_data([])
        setBody_task_data(await comm_getTaskTeam(token_id, currentUser, params.row.team_id, params.row.task_id, params.row.target_user_id))
        
    }


    function handleClickAccordion(task_id){
        // console.log("🚀 ~ file: TaskTeams.js:336 ~ handleClickAccordion ~ task_id:", task_id)
        // console.log("🚀 ~ file: TaskTeams.js:336 ~ handleClickAccordion ~ task_id_selected:", task_id_selected)
        if (task_id_selected === task_id) {
            // console.log("🚀 ~ file: TaskTeams.js:336 ~ handleClickAccordion ~ CLOSE")
            setTask_id_selected('')
        }else {
            // console.log("🚀 ~ file: TaskTeams.js:336 ~ handleClickAccordion ~ OPEN")
            setTask_id_selected(task_id)
        }

        if (isAdmin){
            setTarget_user_id('ADMIN')
        }
    };

    function handleChangeSelectionTargetUser(e){
        // console.log(e.target.value)
        const user_id = e.target.value.replace(/.*\[(.*?)\].*/, "$1");
        setTarget_user_id(user_id)
    }

    async function handleSendFormCreateTask(data) {
        try{
            await comm_createTaskTeam(token_id, currentUser, data);
            
        }catch(e){
            console.error(e)
        }
        await comm_updateTeam(token_id, currentUser, infoTeam['_id'], data)
        refresh_InfoTeam()
    }


    async function handleUpdateFormTask(task_id, data) {
        try{
            // await comm_createTaskTeam(token_id, currentUser, data);
            await comm_updateTaskTeam(token_id, currentUser, task_id, data)
        }catch(e){
            console.error(e)
        }
        await comm_updateTeam(token_id, currentUser, infoTeam['_id'], data)
        refresh_InfoTeam()
    }


    // useEffect(() => {
    //     console.log("🚀 ~ file: TaskTeams.js:758 ~ TaskTeams ~ remove_params_ref.current:", remove_params_ref.current)
    // },[remove_params_ref.current]);



    



    return (
    <>
        {isAdmin ? 
            <div className="sig_BugReport_ButtonsContainer" style={{margin: '10px'}}>
                <Button data-tour="tourBug_2" style={{minWidth: '50%'}} className="sig_SignDialog_Button sig_SignDialog_Button_ReportBug" onClick={() =>{setOpenDialogCreateTaskForm(true)}}>
                  <AssignmentIcon className="sig_VersusMachine_Start_Icon" fontSize="large"/> {t("strButton.btn_create_task").toUpperCase()}
                </Button>
            </div>  
         : <></>
        }

        <Paper className="sig_Teams_ClassroomRoot">
            {resume_task_data.map((item, index) => {
                const { _id, task_id, information, data, visibility, deadline_timestamp, timeLeft } = item;
                const arrowUpStyle = index === 0 ? { color: 'white' } : {};
                const arrowDownStyle = index === resume_task_data.length - 1 ? { color: 'white' } : {}; 
                const isHide = visibility
                timeEndDetectedRef.current = {
                    ...timeEndDetectedRef.current,
                    [_id]: timeLeft < 0
                };

                return (isAdmin || isHide) && (
                    <>
                    <Accordion className="sig_Teams_Classroom" key={_id} expanded={task_id_selected === _id}>
                        <AccordionSummary 
                            className="sig_Teams_Classroom_Summary"
                            expandIcon={<ExpandMoreIcon className="sig_Teams_TaskExpandIcon" />}
                            aria-controls="panel1a-content" 
                            id={"summary_"+_id} 
                            onClick={() => handleClickAccordion(_id)} >

                                    
                            <div className='sig_Teams_TaskRoot'>
                                { isAdmin ? 
                                    <div className='sig_Teams_TaskControls'>
                                        <IconButton onClick={(e) => { sendHideTask(_id, isHide); e.stopPropagation()}}>{isHide ? <VisibilityIcon color='success' fontSize='small'/> : <VisibilityOffIcon color='error' fontSize='small'/>}</IconButton>

                                        {infoTeam['closed'] === false && <IconButton onClick={(e) => { setPrevTaskFormData(item); setOpenDialogCreateTaskForm(true); e.stopPropagation()}}><ModeEditIcon color='primary' fontSize='small'/></IconButton>}

                                        {/* <IconButton onClick={(e) => { setIsConfirmDialogOpen(prevState => ({ ...prevState, [_id]: true })); e.stopPropagation()}}><CloseIcon color='error' fontSize='small'/></IconButton> */}
                                        
                                        <IconButton disabled={index === 0} onClick={(e) => { sendChangePositionTask(index, true); e.stopPropagation()}}><ArrowUpwardIcon color='success' fontSize='small' style={arrowUpStyle}/></IconButton>
                                        <IconButton disabled={index === resume_task_data.length - 1} onClick={(e) => { sendChangePositionTask(index, false); e.stopPropagation()}}><ArrowDownwardIcon color='error' fontSize='small' style={arrowDownStyle}/></IconButton>
                                    </div>
                                    :   
                                    <div style={{ minWidth: '40px' }}></div>
                                }
                                
                                    <div className='sig_Teams_TaskDetails'>
                                        <Typography> <strong>{task_id}</strong> : {information} </Typography>
                                        { deadline_timestamp !== undefined && deadline_timestamp !== '' &&
                                            <div className='sig_Teams_TaskDetails_Stats'>
                                                <div className='sig_Teams_TaskChipContainer sig_Teams_TaskChipTimeContainer'>
                                                        
                                                            <Chip className='sig_Teams_Chip sig_Teams_ChipTime' 
                                                                label={<><strong>Fecha límite:</strong> {formatHistoryDate(deadline_timestamp)} </>} />
                                                            <Chip className='sig_Teams_Chip sig_Teams_ChipTime' 
                                                                style={{borderColor: timeLeft < 0 ? '#ff00006b' : '#03c303'}} 
                                                                label={<><strong>Restante:</strong> {formatDiffDate(timeLeft)} </>} />
                                                        
                                                </div>
                                            </div>
                                        }

                                        <div className='sig_Teams_TaskDetails_Stats'>
                                            { target_user_id === 'ADMIN' ?    
                                                <div className='sig_Teams_TaskChipContainer'>
                                                    <Chip className='sig_Teams_Chip' label={<><strong>Usuarios:</strong> {data['total']}</>} />
                                                    <Chip className='sig_Teams_Chip' style={{
                                                        borderColor: data['participation'] === data['total'] ? '#05f805' : data['participation'] === 0 ? 'red' : 'darkorange'
                                                        }} label={<><strong>Participaron:</strong> {data['participation']}</>} />
                                                    <Chip className='sig_Teams_Chip' style={{
                                                        borderColor: data['completed'] === data['total'] ? '#05f805' : data['completed'] === 0 ? 'red' : 'darkorange'
                                                        }} label={<><strong>Completaron:</strong> {data['completed']}</>} />
                                                    <Chip className='sig_Teams_Chip' label={<><strong>Revisados:</strong> {data['revised']}</>} />
                                                </div>
                                            
                                                :
                                        
                                                <div className='sig_Teams_TaskChipContainer'>
                                                    <Chip className='sig_Teams_Chip sig_Teams_ChipPurple' label={<><strong>Vídeos:</strong> {data['total']}</>} />

                                                    <Chip className='sig_Teams_Chip' style={{
                                                        borderColor: data['participation'] === data['total'] ? '#03c303' : data['participation'] === 0 ? 'red' : 'darkorange'
                                                        }} label={<><strong>Participaciones:</strong> {data['participation']}</>} />

                                                    
                                                    <Chip className='sig_Teams_Chip sig_Teams_ChipBlue' label={<><strong>Revisados:</strong> {data['revised']}</>} />
                                                </div>                                        
                                            }
                                        </div>
                                    </div>
                                </div>
                        </AccordionSummary>

                        <AccordionDetails>
                            { isAdmin ? 
                                <Select 
                                    fullWidth
                                    className="sig_Teams_Select"
                                    size="small"
                                    value={target_user_id}
                                    onChange={(e) => handleChangeSelectionTargetUser(e)}
                                    style={{ textAlign: 'center' }}
                                >
                                    <MenuItem value="ADMIN">
                                        <em> {t("all")} </em>
                                    </MenuItem>

                                    {listActiveMembers.map((usuario, index) => (
                                        <MenuItem key={index} value={usuario.replace(/.*\[(.*?)\].*/, "$1")}>
                                            <em>{usuario}</em>
                                        </MenuItem>
                                    ))}
                                </Select>
                            : <></>
                            }
                                
                                <DataGrid
                                    className="sig_Teams_DG sig_TaskTeams_DG"
                                    autoHeight
                                    pageSize={10}
                                    pagination
                                    columns={target_user_id=='ADMIN' ? columnsALL : columns}
                                    loading={isLoadingDataGrid}
                                    rows={arrDataGrid}
                                />
                        </AccordionDetails>

                    </Accordion>
                    <ConfirmationDialog open={isComfirmDialogOpen[_id]} onClose={() => setIsConfirmDialogOpen(prevState => ({ ...prevState, [_id]: false }))} onConfirm={() => { sendDeleteTask(_id); setIsConfirmDialogOpen(prevState => ({ ...prevState, [_id]: false }))}} message={t("sConfirmationDialog.question_exec_action")}/>

                    </>
                    )   
                })
            }
        </Paper>
        


      <SignDialog dialogElements={dialogElements} setDialogElements={setDialogElements} loading={false} openDialog={openDialogSign} setOpenDialog={setOpenDialogSign} prevDialogPosition={prevDialogPosition} setPrevDialogPosition={setPrevDialogPosition} teamTask={{'team_id': infoTeam['_id'], 'task_id': task_id_selected, isAdmin: isAdmin}}/>       
      <FormCreateTaskDialog 
        openDialog={openDialogCreateTaskForm} 
        setOpenDialog={setOpenDialogCreateTaskForm} 
        prevTaskFormData={prevTaskFormData} 
        setPrevTaskFormData={setPrevTaskFormData} 
        handleSendFormCreateTask={handleSendFormCreateTask} 
        handleUpdateFormTask={handleUpdateFormTask}
        sendHideTask={sendHideTask}
        sendDeleteTask={sendDeleteTask}
        infoTeam={infoTeam}
        />
      <RecordDialog openDialog={openDialogRecord} setOpenDialog={setOpenDialogRecord} selected_record={selected_record} selected_video={selected_video} selected_videoRef={selected_videoRef} updateArr_Records={refresh_InfoTeam} isEvaluationVisible={true} isAdmin={isAdmin}/>


      <ConfirmationDialog open={openComfirmCancelDialog} onClose={() => setOpenComfirmCancelDialog(false)} onConfirm={handleDiscardRecord} message={t("sConfirmationDialog.question_exec_action")}/>
      <Dialog open={openDialogReportRecord} onClose={()=>setOpenDialogReportRecord(false)}> 
        <DialogContent>
            <DialogInfo server_report_activity={server_report_activity} user_vid_original={user_vid_original} user_vid_keypoints={user_vid_keypoints} user_vid_overlay={user_vid_overlay} />
        </DialogContent>
      </Dialog>

    </>
    );
}